import React, { useState } from 'react'

import classNames from 'classnames'
import { Link } from 'react-router-dom'

import Tooltip from '@components/shared/Tooltip'
import Collection from '@models/Collection'
import PageRoutes from '@utils/page-routes'

interface Props {
  collections?: Collection[]
  className?: string
  numShown: number
}

const CollectionTags: React.FC<Props> = ({ collections, className, numShown }: Props) => {
  const [showHidden, setShowHidden] = useState(false)

  // Only show first 2 collections
  const shownCollections = (collections ?? []).slice(0, numShown)

  // All other collections are hidden in a tippy
  const hiddenCollections = (collections ?? []).slice(numShown)

  return (
    <div className={classNames('flex flex-row items-center', className)}>
      {shownCollections.map((collection) => (
        <Link
          to={PageRoutes.homeCollectionPath(collection.id)}
          title={collection.name}
          key={`collection-tag-${collection.id}`}
          onClick={(e) => {
            e.stopPropagation()
          }}
          className="text-xs px-1.5 py-0.5 rounded bg-gray-light dark:bg-black-bg mr-1.5 hover:text-primary max-w-[110px] ellipsify">
          {collection.name}
        </Link>
      ))}
      {hiddenCollections.length > 0 && (
        <Tooltip
          visible={showHidden}
          onHide={() => setShowHidden(false)}
          placement="bottom"
          arrow
          interactive
          content={
            <div className="text-sm py-1">
              {hiddenCollections.map((collection) => (
                <Link
                  to={PageRoutes.homeCollectionPath(collection.id)}
                  title={collection.name}
                  key={`collection-tag-${collection.id}`}
                  className="block cursor-pointer not-last:mb-2 hover:opacity-80">
                  {collection.name}
                </Link>
              ))}
            </div>
          }
          onClickOutside={() => setShowHidden(false)}>
          <button
            type="button"
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              setShowHidden(true)
            }}
            className="text-xs px-1.5 py-0.5 rounded bg-gray-light dark:bg-black-bg hover:text-primary">
            &hellip;
          </button>
        </Tooltip>
      )}
    </div>
  )
}

export default CollectionTags
